<template>
  <div class="jump-component" v-if="to">
    <div class="main-jump-box">
      <div class="msg-box">{{msg}}
        <br>{{$tc('page.jump.tip', timeout)}}
        <router-link replace :to="target">{{to_label}}</router-link>
        <br>{{$t('page.jump.wait')}}
      </div>
      <div class="no-jump-box">
        <p style="padding: 6px;">{{$t('page.jump.no_jump')}}
          <Button @click="$router.replace('/')"
                  class="dark-btn">{{$t('page.jump.index')}}</Button>
        </p>
        <p style="padding: 6px;">{{$t('page.jump.to_official')}}
          <Button @click="$router.face.gotoOfficial()"
                  class="dark-btn">{{$t('page.jump.official')}}</Button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'MyJump',
        props: {
            // 跳转目标
            to: [Object, String],
            // 信息
            msg: String,
            // 跳转时间
            seconds: {
                type: Number,
                default: 3
            }
        },
        data () {
            return {
                target: null,
                to_label: '',
                timeout: 0,
                mTimer: null
            }
        },
        watch: {
            to: {
                handler (val) {
                    if (!val) {
                        if (this.mTimer) {
                            clearInterval(this.mTimer);
                            this.mTimer = null;
                        }
                        return;
                    }
                    // 跳转时间
                    let seconds = this.seconds;
                    if (seconds <= 0) {
                        seconds = 3;
                    } else if (seconds >= 1000) {
                        seconds = Math.floor(seconds / 1000);
                    }
                    this.timeout = seconds;

                    // 跳转目标
                    let target = val;
                    // 目标标题
                    if (typeof target !== 'object' || !target.meta) {
                        target = this.$router.match(target);
                    }
                    this.target = target;
                    this.to_label = target.meta.title || target.path;

                    // 开始倒计时
                    this.mTimer = setInterval(() => {
                        if (--this.timeout <= 0) {
                            if (this.mTimer) {
                                clearInterval(this.mTimer);
                                this.mTimer = null;
                            }
                            if (target) {
                                this.$router.replace(target);
                            }
                        }
                    }, 1000);
                },
                immediate: true
            }
        },
        mounted () {
        },
        beforeDestroy () {
            // 在离开前清除定时器
            if (this.mTimer) {
                clearInterval(this.mTimer);
                this.mTimer = null;
            }
        }
    }
</script>

<style scoped>
  .jump-component {
    padding: 16px;
    text-align: center;
  }
  .main-jump-box {
    display: inline-block;
    width: 100%;
    max-width: 400px;
  }
  .msg-box {
    padding: 16px;
    width: 100%;
    border-radius:5px;
    background-color: #efefef;
    margin-bottom: 16px;
    text-align: center;
  }
  .no-jump-box {
    padding-top: 20px;
    padding-left: 10px;
    text-align: left;
  }
</style>
